import { Button } from '@/components/Button';

interface TutorialStep2Props {
  onNext: () => void;
  onBack: () => void;
}

export default function TutorialStep2({ onNext, onBack }: TutorialStep2Props) {
  return (
    <>
      {/* ステップタイトル */}
      <div className="flex items-center justify-center py-xs">
        <h2 className="text-lg leading-normal font-bold text-black/70">
          ② ログイン、もしくはURLを入力
        </h2>
      </div>

      <div className="flex justify-center gap-xxl p-md">
        <img src="/agent/trial/step2-1.png" alt="" width={424} height={272} />
        <img src="/agent/trial/step2-2.png" alt="" width={424} height={272} />
      </div>

      {/* 進捗インジケーター */}
      <div className="flex h-xxl items-center justify-center gap-[11px]">
        <div className="size-[10px] rounded-full bg-primary" />
        <div className="size-[10px] rounded-full bg-primary" />
        <div className="size-[10px] rounded-full border border-solid border-primary" />
      </div>

      {/* ボタン */}
      <div className="flex justify-center gap-md py-xs">
        <Button color="secondary" size="lg" className="h-[52px] w-[200px]" onClick={onBack}>
          戻る
        </Button>
        <Button color="primary" size="lg" className="h-[52px] w-[200px]" onClick={onNext}>
          次へ
        </Button>
      </div>
    </>
  );
}
